import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import Button from "../../../components/shared/buttons/button";
import { useCreateWasteReturnDataMutation } from "./processingMenuApi";
import useTranslator from "../../../hooks/useTranslator";

const WasteLogModal = ({ show, setShow, data }) => {
  const [addData] = useCreateWasteReturnDataMutation();
  const initialFormData = {
    trey_waste: "",
    case_waste: "",
    total_kg_returned: "",
    total_kg_waste: "",
  };
  const [formData, setFormData] = useState(initialFormData);
  const { _t } = useTranslator();

  useEffect(() => {
    const updatedFormData = { ...initialFormData };

    for (const key in data) {
      if (key in initialFormData) {
        // Check if the key exists in formData
        updatedFormData[key] = data[key];
      }
    }
    setFormData(updatedFormData);
  }, [show, data]);
  const handleClose = () => {
    setShow(false);
  };
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addData(formData).unwrap();
      handleClose();
    } catch (error) {
      console.error("Error creating/updating manager:", error);
    }
  };
  const renderFormFields = () => (
    <>
      <Col lg={6}>
        <InputWithLabel
          label={_t("total_kg_returned", "Total KG Returned")}
          type="number"
          name="total_kg_returned"
          value={formData.total_kg_returned}
          onChange={handleChange}
          placeholder={"0"}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("total_kg_waste", "Total KG Waste")}
          type="number"
          name="total_kg_waste"
          value={formData.total_kg_waste}
          onChange={handleChange}
          placeholder={"0"}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("case_waste", "Case Waste")}
          type="number"
          name="case_waste"
          value={formData.case_waste}
          onChange={handleChange}
          placeholder={"0"}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("trey_waste", "Trey Waste")}
          type="number"
          name="trey_waste"
          value={formData.trey_waste}
          onChange={handleChange}
          placeholder={"0"}
        />
      </Col>
    </>
  );

  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={_t("waste_title", "Waste and Return Log")}
    >
      <Row>{renderFormFields()}</Row>
      <Row>
        <Col className="text-end">
          <Button
            label={_t("save_changes", "Save Changes")}
            size="small"
            onClick={handleSubmit}
          // isLoading={isCreating}
          />
        </Col>
      </Row>
    </CommonModal>
  );
};

export default WasteLogModal;
